import Image from 'next/image';
import { motion, type HTMLMotionProps } from 'framer-motion';

import { cn } from '#/lib/utils';

import image from './images/star.png';

export function Star({ className, ...props }: HTMLMotionProps<'div'>) {
  return (
    <motion.div {...props} className={cn('file:blur-sm', className)}>
      <Image {...image} alt="Star" className="w-full h-full object-cover" />
    </motion.div>
  );
}
